import { graphql } from '../../../graphql/generated';

export const LAB_NEWS_QUERY = graphql(`
  query LabNews($labId: ID!) {
    labNews(labId: $labId) {
      id
      active
      heading
      content
      link1Href
      link1Text
      link2Href
      link2Text
      link3Href
      link3Text
      attachment1Id
      attachment1Filename
      attachment1Size
      attachment2Id
      attachment2Filename
      attachment2Size
      attachment3Id
      attachment3Filename
      attachment3Size
    }
  }
`);

export const UPDATE_NEWS_MUTATION = graphql(`
  mutation UpdateNews($input: NewsUpdateInput!) {
    updateNews(input: $input) {
      id
    }
  }
`);

export const DELETE_NEWS_ATTACHMENT_MUTATION = graphql(`
  mutation DeleteNewsAttachment($labId: ID!, $number: Int!) {
    deleteNewsAttachment(labId: $labId, number: $number) {
      id
    }
  }
`);
